import { Box, Button } from '@factorialco/deprecated-design-system'
import { ReactivateCardDocument, ReactivateCardMutation } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { BankingCard } from 'modules/banking/lib/cards/types'

interface ModalProps {
  card: BankingCard
  onClose: () => void
}

export const ReactivateModal = ({ card, onClose }: ModalProps) => {
  const [reactivateCard, { loading }] = useMutation(ReactivateCardDocument, {
    extractorFn: (data: ReactivateCardMutation) => data.bankingMutations.reactivateBankingCard,
  })

  const handleSubmit = async () => {
    const res = await reactivateCard({ variables: { id: card.id + '' } })
    const result = handleResult(res, (errors) => {
      app.setFlash({
        type: 'wrong',
        message: errors['messages'] || i18n.t('errors.generic_error'),
      })
    })

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('expenses_v2.cards.actions.modal.reactivate.success'),
      })
    }

    onClose()
  }

  return (
    <Modal
      title={i18n.t('expenses_v2.cards.actions.modal.reactivate.title')}
      description={i18n.t('expenses_v2.cards.actions.modal.reactivate.description')}
      illustration="alert"
      onSubmit={handleSubmit}
      onClose={onClose}
      footer={
        <Box flexDirection="row" gap="s16">
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit disabled={loading}>
            {i18n.t('expenses_v2.cards.actions.modal.reactivate.text')}
          </Button>
        </Box>
      }
    />
  )
}
